import { HelmetDexteel } from "@dexteel/mesf-core";
import { InformationRetrieval } from "./components/InformationRetrieval";

export const InformationRetrievalPage = () => {
	return (
		<>
			<HelmetDexteel title="Mill Information Retrieval" />
			<InformationRetrieval />
		</>
	);
};
